import Alpine from "alpinejs";
import { getQueryParam } from "@src/js/utils/http";
import { OrganisationService } from "@src/js/services/organisationService";
import { FeatureFlagService } from "@src/js/services/featureFlagService";
Alpine.data("organisationDetail", () => ({
    organisation: {},
    availableFlags: [],
    selectedFlagId: '0',
    async init() {
        const idParam = getQueryParam('id');
        const id = idParam ? parseInt(idParam) : null;
        if (!id) {
            alert('Missing organisation ID.');
            return;
        }
        try {
            const org = await OrganisationService.getById(id);
            this.organisation = org;
            this.availableFlags = await FeatureFlagService.getAll();
        }
        catch (e) {
            alert((e instanceof Error) ? e.message : 'Failed to load organisation');
        }
    },
    async save() {
        try {
            await OrganisationService.save(this.organisation);
            this.$dispatch('notify', { content: "Organisation saved", type: 'success' });
        }
        catch (e) {
            alert((e instanceof Error) ? e.message : 'Failed to save organisation');
        }
    },
    addFeatureFlag() {
        console.log("Adding feature flag with ID", this.selectedFlagId);
        if (this.selectedFlagId === '0') {
            console.log("No feature flag selected");
            return;
        }
        const selectedId = parseInt(this.selectedFlagId);
        const flagToAdd = this.availableFlags.find(f => f._id === selectedId);
        if (!flagToAdd) {
            console.log("havent found flag with id", this.selectedFlagId, "in available flags", this.availableFlags);
            return;
        }
        const alreadyAssigned = this.organisation.featureFlags.some(f => f._id === flagToAdd._id);
        if (!alreadyAssigned) {
            this.organisation.featureFlags.push(flagToAdd);
        }
        this.selectedFlagId = '0';
    },
    removeFeatureFlag(flag) {
        this.organisation.featureFlags = this.organisation.featureFlags.filter(f => f._id !== flag._id);
    }
}));
